import angular from 'angular';

export default angular.module('gallery', ['ngDialog'])
.directive('gallery', gallery)
.directive('galleryToggle', galleryToggle)
.controller('galleryDialogCtrl', galleryDialogCtrl);

gallery.$inject = [];

function gallery($scope) {
	var directive = {
		restrict: 'A',
		scope: {},
		controller: controller,
		link: link,
		transclude: true
	};
	
	controller.$inject = ['$scope'];

	return directive;

	function controller($scope) {
		$scope.items = [];
		
		this.addItem = (item) => {
			$scope.items.push(item);
		};
	}
	
	function link(scope, elem, attr, ctrl, transclude) {
		transclude(scope, function(clone) {
			elem.append(clone);
		})
	}
}

galleryToggle.$inject = ['ngDialog'];

function galleryToggle(ngDialog) {
	var directive = {
		link: link,
		restrict: 'A',
		require: '^gallery',
		scope: true
	};
	return directive;

	function link(scope, element, attrs, galleryCtrl) {
		element.on('click', (e) => {
			e.preventDefault();
			
			ngDialog.open({
				showClose: false,
				template: `${wp.template_directory_uri}/templates/gallery.html`,
				className: 'ngdialog-theme-custom',
				controller: 'galleryDialogCtrl',
				data: {
					index: parseInt(attrs.galleryIndex, 10),
					items: scope.items
				}
			});
		});

		galleryCtrl.addItem(attrs.galleryToggle);
	}
}

galleryDialogCtrl.$inject = ['$scope'];

function galleryDialogCtrl($scope) {
	$scope.active = angular.copy($scope.ngDialogData.index);
	$scope.items = angular.copy($scope.ngDialogData.items);
	
	$scope.next = () => {
		if ( $scope.active === $scope.items.length - 1 ) {
			return $scope.active = 0;
		}
		
		return $scope.active++;
	};
	
	$scope.prev = () => {
		if ( $scope.active === 0 ) {
			return $scope.active = $scope.items.length - 1;
		}
		
		return $scope.active--
	};
}



/** WEBPACK FOOTER **
 ** ./src/js/gallery/gallery.js
 **/